import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getCenterPage, homeSelect } from 'redux-api/slices/HomeSlice';
import { PATHS } from 'common/constants';
import centerShape from 'assets/icons/home/hmCenterShape.svg';
import centerPhoto from 'assets/image/home/hmCenterPhoto.webp';
import HomeButton from './HomeButton';
import classes from './HomeCenter.module.scss';


const HomeCenter = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { centerPage = {} } = useSelector(homeSelect);

  useEffect(() => {
    dispatch(getCenterPage());
    return () => null;
  }, [ dispatch ]);

  return (
    <section className={classes.center}>
      <div className={classes.container}>
        <div className={classes.inner}>
          <div className={classes.text}>
            <h2 className={classes.title} data-aos="fade-up">{centerPage.title}</h2>
            <p className={classes.thesis} data-aos="fade-up" data-aos-delay="100">{centerPage.text}</p>
            <div className={classes.action} data-aos="fade-up" data-aos-delay="200">
              <HomeButton to={PATHS.aboutUs}>{t('MoreAboutUs')}</HomeButton>
            </div>
          </div>

          <div className={classes.media} data-aos="fade-left" data-aos-delay="100">
            {/* Жёлтая подложка из макета — фото стоит на ней. */}
            <img className={classes.shape} src={centerShape} alt="" />
            <div className={classes.photoClip}>
              <img className={classes.photo} src={centerPhoto} alt={centerPage.title || ''} loading="lazy" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeCenter;
